import { render } from "./GroupProduct.vue?vue&type=template&id=47ea8944&scoped=true"
import script from "./GroupProduct.vue?vue&type=script&lang=js"
export * from "./GroupProduct.vue?vue&type=script&lang=js"

import "./GroupProduct.vue?vue&type=style&index=0&id=47ea8944&lang=scss&scoped=true"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ea8944"]])

export default __exports__